(($) => {
    
    $(window).on('load', () => {
        let hash = window.location.hash.replace('#', '');
        const elem = $('#'+hash);
        if(elem.length && hash.length){
            const $header = $('body > .banner');
            let heightFix = !$header.hasClass('fixed') ? $header.outerHeight() : 0;
            heightFix += elem.offset().top < window.scrollY ? $header.outerHeight() : 0;
            window.scrollTo(0, (elem.offset().top - 30 - heightFix));
        }
    });

    $(document).ready(function(){
        $('a').each(function () {
            let $goToAnchor = $(this);
            $goToAnchor.on('click', function (e) {
                let elem = $('[data-anchor="'+$goToAnchor.attr('href').replace('#', '')+'"]');
                if(elem.length){
                    e.preventDefault();
                    window.scrollTo(0, (elem.offset().top - 110));
                }
            })
        })
    });

})($);


// WEBPACK FOOTER //
// ./scripts/components/go-to-anchor.js